import React from 'react'
import { chooseWallpaper, checkTranslation, translate, conditionalWidth } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import LoaderButton from '../../components/LoaderButton';
import BottomSheet from '../../components/BottomSheet';
import HttpServices from '../../utils/Http.services';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';


class CredentialsType extends React.Component {
    state = {
        pages: [
            { key: 'credentials', label: 'Credentials', icon: '/images/icons/credentials.svg', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'rooms', label: 'Your Rooms', icon: '/assets/icons/fi-sr-info.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'schedule', label: 'Schedule', icon: '/assets/icons/fi-sr-apps.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
            { key: 'history', label: 'History', icon: '/assets/icons/fi-sr-megaphone.png', description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.' },
        ],
        currentPage: 'dashboard',

        applet: [
            { name: 'Yonnect Bot', type: 'messenger-bot', description: 'This is the description of this applet type', icon: '/images/icons/y1.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y2.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y3.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y4.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y5.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y6.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y7.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y8.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y9.png' },
            { name: 'Applet name', description: 'This is the description of this applet type', icon: '/images/icons/y10.png' },
        ],
        currentTab: 'yonnect',
        currentSubTab: 'details',
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }


    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }

    openApplet = (item) => {

        this.bottomSheet.open()
        this.setState({ currentItem: item })
    }

    confirmApplet = () => {

    }

    createToken = () => {
        this.setState({ isLoading: true })
        HttpServices.request('createToken', { type: this.state.currentItem?.type }, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })

            if (fetchError) {
                console.log(fetchError);

                this.props.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
            }


            console.log('token', fetchResult);
            this.props.setData("data", fetchResult?.info, () => {
                console.log("Created")
                this.props.changeStage("CredentialsKey")
            })
            // this.setState({ messageBot: fetchResult.info })
        })
    }

    selectTap = (key) => {
        this.setState({ currentTab: key })
    }

    selectSubTap = (key) => {
        this.setState({ currentSubTab: key })
    }


    render() {
        let applet = this.state.applet;
        return (

            <div className="window-content-radius" style={{ backgroundColor: '#F5F5F5' }} >
                <div className='p-2 m-2 br-10 flexc' style={{ background: 'linear-gradient(90deg, #F4EBEB, #F4EBEB)' }}>
                    <img src='/assets/icons/notif-red.svg' />
                    <p className='font-size-12' style={{ color: '#B22626' }}>Find out what kind of credentials you need.<span className='mld-2'>You can explore applets Blow.</span></p>
                </div>
                <div className='px-2'>
                    <div className='d-flex flexcc w-100 p-1 br-10 bg-white'>
                        <button className={' w-100 py-2 br-8 ' + (this.state.currentTab == 'yonnect' ? 'developer-tab-active' : 'developer-tab-deactive')} onClick={() => this.selectTap('yonnect')}>
                            <p style={{ fontSize: '14px', }} className='text-bold'>{translate('Yonnect')}</p>
                        </button>
                        <button className={' w-100 py-2 br-8 ' + (this.state.currentTab == 'thirdParty' ? 'developer-tab-active' : 'developer-tab-deactive')} onClick={() => this.selectTap('thirdParty')}>
                            <p style={{ fontSize: '14px', }} className='text-bold'>{translate('Third Party')}</p>
                        </button>
                    </div>
                </div>
                <div className='mt-3 d-flex w-100 flex-wrap'>
                    {applet.map((item, index) => {
                        return (
                            <Responsive className={'p-2'} width={this.props.width} media={{ xs: "12", sm: '6', lg: '3' }} >
                                <div className='w-100'>
                                    <button onClick={() => this.openApplet(item)} className='developer-border-box br-10 p-3 w-100'>
                                        <div className='flexc'>
                                            <img src={item.icon} height={40} />
                                        </div>
                                        <p className='text-start text-small text-bold mt-2'>{item.name}</p>
                                        <p className='text-start text-smaller mt-0'> {item.description}</p>
                                    </button>
                                </div>
                            </Responsive>
                        );
                    })}
                </div>
                <BottomSheet ref={el => this.bottomSheet = el} width={this.props.width}>
                    <div>
                        <div className='bg-developer pt-3' style={{ marginTop: -20 }}>
                            <div className='px-4 flexcb'>
                                <div className='flexc'>
                                    <img src={this.state.currentItem?.icon} height={40} />
                                    <div className='mx-3'>
                                        <p className="text-bold text-normal mb-0 color-dark-blue-1" >{checkTranslation(this.state.currentItem?.name)}</p>
                                        <div style={{ maxWidth: 450 }}>
                                            <p className="mt-0 text-small color-dark-blue-1" >{translate('Select the applet they ypu want to continue with')}</p>
                                        </div>
                                    </div>
                                </div>

                                <div >
                                    {/* <LoaderButton
                                        onClick={() => { this.createToken() }}
                                        isLoading={this.state.isLoading}
                                        text={translate("Add new")}
                                        backgroundImage='linear-gradient(45deg, #30A1B8 0%, #5598DE 40%, #8E81F4  70%, #F45495  90%, #EE4358  100%)'
                                        shadow="0px 0px 14px -7px #007aff;"
                                        icon={'/assets/icons/plus.svg'}
                                        className={'button-interactive-1'}
                                    /> */}
                                    <ButtonAnimated icon={'/assets/icons/plus-white.svg'} iconwidth={'28px'} bg={'linear-gradient(90deg, #B22626, #DD3A3A)'} title={'{{lang}}Create'} width={'100%'} onClick={() => { this.createToken() }} />

                                </div>
                            </div>

                            <div className='px-4 mt-3 '>
                                <button className={'text-normal mrd-4 mb-2 px-2 py-1 br-20 ' + (this.state.currentSubTab == 'details' ? 'developer-tab-active' : 'developer-tab-deactive')} onClick={() => this.selectSubTap('details')}>
                                    <p className='text-small'>Details</p>
                                </button>
                                <button className={'text-normal mrd-4 mb-2 px-2 py-1 br-20 ' + (this.state.currentSubTab == 'reviews' ? 'developer-tab-active' : 'developer-tab-deactive')} onClick={() => this.selectSubTap('reviews')}>
                                    <p className='text-small'>Reviews</p>
                                </button>
                                <button className={'text-normal mrd-4 mb-2 px-2 py-1 br-20 ' + (this.state.currentSubTab == 'technical' ? 'developer-tab-active' : 'developer-tab-deactive')} onClick={() => this.selectSubTap('technical')}>
                                    <p className='text-small'>Technical</p>
                                </button>
                            </div>
                        </div>
                        <div className='px-4 d-flex flex-wrap pt-4'>
                            <Responsive width={this.props.width} media={{ xs: '12', md: '8', lg: "8", xl: "8" }} >
                                <div className={'' + (conditionalWidth(this.props.width, { xs: 'prd-0', md: 'prd-4' }))}>
                                    <p className='text-normal text-bold mb-2'>Description</p>
                                    <p className='text-small '>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laboriosam, alias ratione. Repellat, voluptatibus doloribus adipisci, a ipsam dicta maiores impedit temporibus voluptas harum necessitatibus eum quasi? Assumenda illum dicta sint!</p>
                                </div>
                            </Responsive>

                            <Responsive width={this.props.width} media={{ xs: '12', md: '4', lg: "4", xl: "4" }} >
                                <div className={'bb-1 pb-2 mb-2 flexcb ' + (conditionalWidth(this.props.width, { xs: 'mt-4', md: 'mt-0' }))}>
                                    <p className='text-small'>{translate("Created By")} </p>
                                    <p className='text-bold text-small'>Yonnect team</p>
                                </div>

                                <div className='bb-1 pb-2 mb-2 flexcb'>
                                    <p className='text-small'>{translate("Tags")} </p>
                                    <p className='text-smaller tag-style px-2 py-1'>University</p>
                                </div>

                            </Responsive>

                        </div>

                    </div>
                </BottomSheet>

            </div>

        )
    }
}

export default CredentialsType;